import { Navigate, useRoutes } from "react-router-dom";
import ADataExplorer from "src/micro/ADataExplorer/ADataExplorer";
import BotCretor from "src/micro/BotCreator/BotCretor";
import CaseByID from "src/micro/Chat/CaseByID";
import CaseList from "src/micro/Chat/CaseList";
import ChatList from "src/micro/Chat/ChatList";
import ThreadByID from "src/micro/Chat/ThreadByID";
import Eq from "src/micro/Eq/Eq";

export default function Router() {
  return useRoutes([
    {
      path: "/",
      children: [
        {
          element: <ChatList />,
          index: true,
        },
        { path: ":id", element: <ThreadByID /> },
        { path: "explorer", element: <ADataExplorer /> },
        { path: "case-notes", element: <CaseList /> },
        { path: "case-notes/:id", element: <CaseByID /> },
        { path : "bot-create", element : <BotCretor /> },
        // put path: "eq" and whatever component
        { path: "eq", element: <Eq /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
